/* eslint-disable */
import Amplify, { Auth, Hub } from 'aws-amplify';
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserAttribute,
  CognitoUserPool,
  CognitoRefreshToken,
} from 'amazon-cognito-identity-js';
import { IAuthAWS, IOAuth } from '../interfaces/IAuthAWS';
import { FederatedSignInOptions } from '@aws-amplify/auth/lib-esm/types';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import * as AWS from 'aws-sdk';
// import { Alert, Platform } from 'react-native';

// import InAppBrowser from 'react-native-inappbrowser-reborn';

import {
  IRegisterParam,
  SocialMedia,
} from '../interfaces/IAuthFunctionalities';
import { IUserAuth } from '../interfaces/IUserAuth';
import { generatePassword } from '../utils/helpers';
import {
  changePhone,
  confirmChangeEmail,
  confirmChangePhone,
  changeEmail,
  adminDisableUser,
  adminEnableUser,
  getMFAPreference,
  setMFAPreference,
} from '../services/cognito';
import { AWS_CONFIG } from '../config/config';
let userPool: CognitoUserPool;
let currentUser: CognitoUser;

export const initCognito = async (authProps: IAuthAWS) => {
  const poolData: any = {
    UserPoolId: authProps.userPoolId,
    ClientId: authProps.userPoolWebClientId,
  };
  Amplify.configure(authProps);
  userPool = new CognitoUserPool(poolData);

  if (userPool) currentUser = <CognitoUser>userPool.getCurrentUser();
  else currentUser = await Auth.currentAuthenticatedUser();
};

export const getCurrentUser = async () => {
  currentUser = await Auth.currentAuthenticatedUser();
  return currentUser;
};

function getCognitoUser(username: string) {
  const userData = {
    Username: username,
    Pool: userPool,
  };
  if (!currentUser) {
    const cognitoUser = new CognitoUser(userData);
    return cognitoUser;
  } else {
    if (currentUser.getUsername() !== username) {
      const cognitoUser = new CognitoUser(userData);
      return cognitoUser;
    }
  }
  return currentUser;
}

export async function getSession() {
  return new Promise(function (resolve, reject) {
    Auth.currentSession()
      .then((session: any) => {
        resolve(session);
      })
      .catch((err: any) => {
        reject(err);
      });
  }).catch((err) => {
    throw err;
  });
}

export async function signUpUserWithEmail(
  username: string,
  email: string,
  password: string
) {
  return new Promise(function (resolve, reject) {
    const attributeList = [
      new CognitoUserAttribute({
        Name: 'email',
        Value: email,
      }),
    ];

    userPool.signUp(
      username,
      password,
      attributeList,
      [],
      function (err: any, res: any) {
        if (err) {
          reject(err);
        } else {
          resolve(res);
        }
      }
    );
  }).catch((err: any) => {
    throw err;
  });
}

export async function signUpUserWithPhone(
  username: string,
  email: string,
  password: string,
  name: string,
  phone: string,
  practice: string,
  specialty: string,
  role: string,
  state: string,
  firstName?: string,
  lastName?: string
) {
  return new Promise(function (resolve, reject) {
    const attributeList = [
      new CognitoUserAttribute({
        Name: 'email',
        Value: email,
      }),
      new CognitoUserAttribute({
        Name: 'phone_number',
        Value: phone,
      }),
      new CognitoUserAttribute({
        Name: 'name',
        Value: name,
      }),
      new CognitoUserAttribute({
        Name: 'custom:practice_name',
        Value: practice,
      }),
      new CognitoUserAttribute({
        Name: 'custom:role',
        Value: role,
      }),
      new CognitoUserAttribute({
        Name: 'custom:speciality',
        Value: specialty,
      }),
      new CognitoUserAttribute({
        Name: 'custom:state',
        Value: state,
      }),
    ];
    userPool.signUp(
      username,
      password,
      attributeList,
      [],
      function (err: any, res: any) {
        if (err) {
          reject(err);
        } else {
          resolve(res);
        }
      }
    );
  }).catch((err) => {
    throw err;
  });
}

export async function verifyCode(username: string, code: string) {
  return new Promise(function (resolve, reject) {
    const cognitoUser = getCognitoUser(username);

    cognitoUser.confirmRegistration(
      code,
      true,
      function (err: any, result: any) {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      }
    );
  }).catch((err) => {
    throw err;
  });
}

export let mfaRequired = false;
let authenticationDetails: AuthenticationDetails;

export async function signInWithEmail(
  username: string,
  password: string,
  callback: () => void,
  setMfaRequired: (required: boolean) => void
) {
  return new Promise(function (resolve, reject) {
    const authenticationData = {
      Username: username,
      Password: password,
    };

    authenticationDetails = new AuthenticationDetails(authenticationData);

    currentUser = getCognitoUser(username);
    // currentUser.setAuthenticationFlowType("CUSTOM_AUTH");
    currentUser.authenticateUser(authenticationDetails, {
      mfaRequired() {
        // Implement you functionality to show UI for MFA form
        mfaRequired = true;
        setMfaRequired(true);
        callback();
      },
      onSuccess: function (res: any) {
        resolve(res);
      },
      onFailure: function (err: any) {
        reject(err);
      },
      customChallenge: function (res: any) {
        mfaRequired = true;
        setMfaRequired(true);
        console.log(res);
        callback();
      },
    });
  }).catch((err) => {
    throw err;
  });
}

export const respondToCustomChallenge = (username: string, MFACode: string) => {
  return new Promise(function (resolve, reject) {
    currentUser.sendCustomChallengeAnswer(MFACode, {
      onSuccess: function (res: any) {
        mfaRequired = false;
        resolve(res);
      },
      onFailure: function (err: any) {
        console.log(err);
        reject(err);
      },
    });
  });
};

export async function signInOTP(username: string, password: string) {
  return new Promise(function (resolve, reject) {
    const authenticationData = {
      Username: username,
      Password: password,
    };

    authenticationDetails = new AuthenticationDetails(authenticationData);
    currentUser = getCognitoUser(username);

    Auth.signIn(username, password)
      .then((user: any) => {
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          throw {
            code: 'NEW_PASSWORD_REQUIRED',
            message: 'Please change your password to have access to the system',
          };
        } else {
          resolve(user);
          // other situations
        }
      })
      .catch((err: any) => {
        reject(err);
      });
  });
}

export const sendMfaCode = (username: string, MFACode: string) => {
  return new Promise(function (resolve, reject) {
    currentUser.sendMFACode(MFACode, {
      onSuccess: function (res: any) {
        mfaRequired = false;
        resolve(res);
      },
      onFailure: function (err: any) {
        reject(err);
      },
    });
  });
};

export const reSendMfaCode = (callback: (sended: boolean) => void) => {
  if (!currentUser || !authenticationDetails) {
    callback(false);
  }
  return new Promise(function (resolve, reject) {
    currentUser.authenticateUser(authenticationDetails, {
      mfaRequired() {
        // Implement you functionality to show UI for MFA form
        mfaRequired = true;
        callback(true);
      },
      onSuccess: function (res: any) {
        resolve(res);
      },
      onFailure: function (err: any) {
        reject(err);
      },
    });
  });
};

export const federatedSignIn = (configAWS: IAuthAWS, provider: SocialMedia) => {
  const updatedConfig: IAuthAWS = {
    ...configAWS,
    oauth: {
      ...(<IOAuth>configAWS.oauth),
      urlOpener: federatedSignInUrlOpener,
    },
  };
  Amplify.configure(updatedConfig);
  const signInOption: FederatedSignInOptions = {
    provider: <CognitoHostedUIIdentityProvider>(<unknown>provider),
  };
  Auth.federatedSignIn(signInOption);
};

const federatedSignInUrlOpener = async (url: any, redirectUrl: any) => {
  // try {
  //   if (await InAppBrowser.isAvailable()) {
  //     const result = await InAppBrowser.openAuth(url, getDeepLink(), {
  //       // iOS Properties
  //       ephemeralWebSession: false,
  //       // Android Properties
  //       showTitle: false,
  //       enableUrlBarHiding: true,
  //       enableDefaultShare: false,
  //     });
  //     // Alert.alert('Response', JSON.stringify(result));
  //   } else {
  //     // Alert.alert('InAppBrowser is not supported :/');
  //   }
  // } catch (err) {
  //   // Alert.alert('Something’s wrong with the app :(');
  // }
};

export const getDeepLink = (path = '') => {
  const scheme = 'topflightapps';
  // const prefix = Platform.OS == 'android' ? `${scheme}://authentication/` : `${scheme}://`
  // return prefix + path
  return path;
};

export function signOut() {
  if (currentUser) {
    currentUser.signOut();
  }
}

export async function getAttributes() {
  currentUser = await getCurrentUser();
  return new Promise(function (resolve, reject) {
    currentUser.getUserAttributes(function (err: any, attributes: any) {
      if (err) {
        reject(err);
      } else {
        resolve(attributes);
      }
    });
  }).catch((err) => {
    throw err;
  });
}

export async function refreshSession(refreshToken: string) {
  if (!currentUser) {
    currentUser = await getCurrentUser();
  }
  if (currentUser)
    return new Promise<unknown | undefined>(function (resolve, reject) {
      currentUser.refreshSession(
        new CognitoRefreshToken({ RefreshToken: refreshToken }),
        function (err: Error | null, result: unknown) {
          if (err) {
            reject(err);
          } else {
            resolve(result);
          }
        }
      );
    }).catch((err) => {
      throw err;
    });
  return;
}

export const refreshToken = (username: string, refreshT: string) => {
  const newToken = new CognitoRefreshToken({ RefreshToken: refreshT });
  if (!currentUser) currentUser = getCognitoUser(username);
  return new Promise(function (resolve, reject) {
    currentUser.refreshSession(newToken, function (err, result) {
      if (err) {
        reject(err);
      }
      resolve(result);
    });
  });
};

export async function setAttribute(attribute: any) {
  return new Promise(function (resolve, reject) {
    const attributeList = [];
    const res = new CognitoUserAttribute(attribute);
    attributeList.push(res);

    currentUser.updateAttributes(attributeList, (err: any, res: any) => {
      if (err) {
        reject(err);
      } else {
        resolve(res);
      }
    });
  }).catch((err) => {
    throw err;
  });
}

export async function setAttributes(attributes: IUserAuth) {
  return new Promise(function (resolve, reject) {
    const attr = attributes.attr;
    const attributeList = [
      new CognitoUserAttribute({
        Name: 'email',
        Value: attributes.email,
      }),
      new CognitoUserAttribute({
        Name: 'phone_number',
        Value: attributes.phone_number,
      }),
      new CognitoUserAttribute({
        Name: 'name',
        Value: attributes.name as string,
      }),
    ];

    currentUser.updateAttributes(attributeList, (err: any, res: any) => {
      if (err) {
        reject(err);
      } else {
        resolve(res);
      }
    });
  }).catch((err) => {
    throw err;
  });
}

export async function sendCodeForgotPassword(username: string) {
  return new Promise(function (resolve, reject) {
    const cognitoUser = getCognitoUser(username);

    if (!cognitoUser) {
      reject(`could not find ${username}`);
      return;
    }

    cognitoUser.forgotPassword({
      onSuccess: function (res: any) {
        resolve(res);
      },
      onFailure: function (err: any) {
        reject(err);
      },
    });
  }).catch((err) => {
    throw err;
  });
}

export async function sendCodeRecoverPassword(username: string) {
  return new Promise(function (resolve, reject) {
    const cognitoUser = getCognitoUser(username);
    if (!cognitoUser) {
      reject(`could not find ${username}`);
      return;
    }

    cognitoUser.forgotPassword({
      onSuccess: function (res: any) {
        resolve(res);
      },
      onFailure: function (err: any) {
        reject(err);
      },
    });
  }).catch((err) => {
    throw err;
  });
}

export async function forgotPassword(
  username: string,
  code: string,
  password: string
) {
  return new Promise(function (resolve, reject) {
    const cognitoUser = getCognitoUser(username);
    if (!cognitoUser) {
      reject(`could not find ${username}`);
      return;
    }

    cognitoUser.confirmPassword(code, password, {
      onSuccess: function () {
        resolve('password updated');
      },
      onFailure: function (err: any) {
        reject(err);
      },
    });
  });
}

export async function forgotPasswordToken(username: string, password: string) {
  return new Promise(function (resolve, reject) {
    const cognitoUser = getCognitoUser(username);
    if (!cognitoUser) {
      reject(`could not find ${username}`);
      return;
    }

    /* cognitoUser.confirmPassword(code, password, {
      onSuccess: function () {
        resolve('password updated')
      },
      onFailure: function (err) {
        reject(err)
      },
    }) */
  });
}

export const updatePhone = (phone: string, username: string) => {
  return new Promise(function (resolve, reject) {
    AWS.config.update({
      region: AWS_CONFIG.region,
      // accessKeyId: AWS_CREDENTIALS.accessKeyId,
      // secretAccessKey: AWS_CREDENTIALS.secretAccessKey,
    });
    let cognitoIdentityServiceProvider =
      new AWS.CognitoIdentityServiceProvider();

    let parameters = {
      UserPoolId: AWS_CONFIG.userPoolId,
      Username: username,
      UserAttributes: [
        {
          Name: 'phone_number',
          Value: phone,
        },
      ],
    };

    cognitoIdentityServiceProvider.adminUpdateUserAttributes(
      parameters,
      function (err: any, result: any) {
        if (err) reject(err);
        else resolve(result);
      }
    );
  });
};

export async function changePassword(oldPassword: string, newPassword: string) {
  currentUser = await Auth.currentAuthenticatedUser();
  return new Promise(function (resolve, reject) {
    currentUser.changePassword(
      oldPassword,
      newPassword,
      function (err: any, res: any) {
        if (err) {
          reject(err);
        } else {
          resolve(res);
        }
      }
    );
  });
}

export async function signUpAdmin(email: string) {
  const password: string = generatePassword(8);

  return new Promise(function (resolve, reject) {
    try {
      const cognito = new AWS.CognitoIdentityServiceProvider();
      const params = {
        UserPoolId: 'us-east-2_FsrVdiNB7',
        Username: email,
        TemporaryPassword: password,
        UserAttributes: [
          {
            Name: 'email' /* required */,
            Value: email,
          },
          {
            Name: 'email_verified',
            Value: 'true',
          },
          /* more items */
        ],
      };
      cognito.adminCreateUser(params, function (err: any, data: any) {
        if (err) {
          console.log(err.code);
          if (!err.code) resolve(true);
          else reject(err);
        } else {
          resolve(true);
        }
      });
    } catch (e) {
      throw e;
    }
  });
}

export async function disableUser(email: string) {
  try {
    const res = await adminDisableUser(email);
    console.log(res);
    return res;
  } catch (e) {
    throw e;
  }
}

export async function enableUser(email: string) {
  try {
    const res = await adminEnableUser(email);
    console.log(res);
    return res;
  } catch (e) {
    throw e;
  }
}

export async function getMFAOption() {
  try {
    const res = await getMFAPreference();
    return res;
  } catch (e) {
    throw e;
  }
}

export async function setMFAOption(option: boolean) {
  try {
    const res = await setMFAPreference(option);
    return res;
  } catch (e) {
    throw e;
  }
}

export async function completeNewPassword(
  username: string,
  password: string,
  newPassword: string
) {
  return new Promise(function (resolve, reject) {
    Auth.signIn(username, password)
      .then((user: any) => {
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
          Auth.completeNewPassword(
            user, // the Cognito User Object
            newPassword, // the new password
            // OPTIONAL, the required attributes
            {
              phone_number: '+1234567890',
            }
          )
            .then((user: any) => {
              // at this time the user is logged in if no MFA required
              resolve(user);
            })
            .catch((e: any) => {
              reject(e);
            });
        } else {
          resolve(user);
          // other situations
        }
      })
      .catch((e: any) => {
        reject(e);
      });
  });
}

export const sendCode = (username: string, code: string) => {
  var cognitoUser = getCognitoUser(username);
  return new Promise(function (resolve, reject) {
    cognitoUser.confirmRegistration(
      code,
      true,
      function (err: any, result: any) {
        if (err) {
          reject(err);
        }
        resolve(result);
      }
    );
  });
  return;
};

export const reSendCode = async (username: string) => {
  var cognitoUser = getCognitoUser(username);
  return new Promise(function (resolve, reject) {
    cognitoUser.resendConfirmationCode(function (err: any, result: any) {
      if (err) {
        reject(err);
      }
      resolve(result);
    });
  });
};

export const enableMFA = (username: string) => {
  if (!currentUser) currentUser = getCognitoUser(username);
  var smsMfaSettings = {
    PreferredMfa: true,
    Enabled: true,
  };
  return new Promise(function (resolve, reject) {
    currentUser.setUserMfaPreference(
      smsMfaSettings,
      null,
      function (err, result) {
        if (err) {
          //alert(err.message || JSON.stringify(err));
          reject(err);
        }
        resolve(result);
      }
    );
  });
};

export const disableMFA = async (username: string) => {
  // currentUser = getCognitoUser(username);
  currentUser = await getCurrentUser();
  var smsMfaSettings = {
    PreferredMfa: false,
    Enabled: false,
  };
  return new Promise(function (resolve, reject) {
    currentUser.setUserMfaPreference(
      smsMfaSettings,
      null,
      function (err, result) {
        if (err) {
          //alert(err.message || JSON.stringify(err));
          reject(err);
        }
        resolve(result);
      }
    );
  });
};

export const rememberDevice = () => {
  return new Promise(async function (resolve, reject) {
    try {
      currentUser.setDeviceStatusRemembered({
        onSuccess: function (result: any) {
          resolve(result);
        },
        onFailure: function (err: any) {
          reject(err);
        },
      });
    } catch (err: any) {
      reject(err);
    }
  });
};

export const forgotDevice = () => {
  return new Promise(async function (resolve, reject) {
    try {
      currentUser.forgetDevice({
        onSuccess: function (result: any) {
          resolve(result);
        },
        onFailure: function (err: any) {
          reject(err);
        },
      });
    } catch (err: any) {
      reject(err);
    }
  });
};

export const onChangePhoneSubmitted = async (phone: string, email: string) => {
  try {
    const user = await Auth.currentAuthenticatedUser();

    if (
      user.attributes.phone_number === phone &&
      user.attributes.phone_number_verified
    ) {
      throw new Error(`${phone} is already your phone number`);
    }
    await changePhone(phone, email);
    await Auth.currentAuthenticatedUser({ bypassCache: true });
    return true;
  } catch (e) {
    throw e;
  }
};

export const onChangeEmailSubmitted = async (
  newEmail: string,
  email: string
) => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    if (user.attributes.email === newEmail) {
      throw new Error(`${newEmail} is already your email address`);
    }
    await changeEmail(newEmail, email);
    await Auth.currentAuthenticatedUser({ bypassCache: true });
    return true;
  } catch (e) {
    throw e;
  }
};

export const onConfirmCodeResendCodePhone = async (
  phone: string,
  email: string
) => {
  try {
    const emailChanged = await changePhone(phone, email);
    return true;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const onConfirmCodeSubmitted = async (
  code: string,
  NewEmail: string,
  email: string
) => {
  try {
    const currentAuthenticatedUser = await Auth.currentAuthenticatedUser();

    const res = await confirmChangeEmail(code, NewEmail, email);
    console.log(res);
    await Auth.currentAuthenticatedUser({ bypassCache: true });
    return true;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};

export const onConfirmCodeSubmittedPhone = async (
  code: string,
  phone: string,
  email: string
) => {
  try {
    const res = await confirmChangePhone(code, phone, email);
    console.log(res);
    await Auth.currentAuthenticatedUser({ bypassCache: true });
    return true;
  } catch (e: any) {
    console.log(e.message);
    throw e;
  }
};
